import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Subject } from 'rxjs';
import { SelectModel } from 'src/shared/models/select.model';
import $ from 'jquery';

@Component({
  selector: 'app-lms-select',
  templateUrl: './lms-select.component.html',
  styleUrls: ['./lms-select.component.scss'],
})
export class LmsSelectComponent implements OnInit, AfterViewInit, OnDestroy {
  /** Reference to the search input field */
  @ViewChild('inputValue', { read: ElementRef }) inputValue: ElementRef;
  @ViewChild("matSelect") matSelect: MatSelect;
  @Input() customClass: string = 'lms-mat-form-field';
  @Input() dropdownFor: string = 'Content';
  @Input() idForSelect: string = 'lms-demo-0';
  @Input() requiredLabel: string = 'field is required!';
  @Input() multipleSelection: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() formControlsName: FormControl = new FormControl();
  @Input() records: Subject<any>;
  @Input() disabled: boolean = false;
  @Output() dropdownChangeEvent = new EventEmitter<object>();


  public noEntriesFoundText = '';
  public dropdownSearchPlaceholder = '';
  public dropdownChoosePlaceholder = '';
  public lists: SelectModel[] = [];
  protected filteredLists: SelectModel[] = [];

  constructor() { }

  ngOnInit() {
    this.records.subscribe(record => {
      record = record.sort((a, b) => {
        if (a.entityBusinessName === null) {
          return null;
        } else {
          return a.entityBusinessName.trim().localeCompare(b.entityBusinessName?.trim())
        }
      });
      this.lists = record;
      this.filteredLists = cloneObjectWithoutReference(record);
      const isValueExists = this.lists.some(item => item.entityBusinessID === this.formControlsName.value);
      // set formcontrol value null when length of list is greater than 0 
      if (record.length > 0 && !isValueExists) {
        this.formControlsName.setValue(null);
      }
      this.noEntriesFoundText = 'No ' + this.dropdownFor + ' Found';
      this.dropdownSearchPlaceholder = 'Search ' + this.dropdownFor;
      this.dropdownChoosePlaceholder = 'Choose ' + this.dropdownFor;
      this.requiredLabel = this.dropdownFor + ' is required!';
    });
  }

  ngAfterViewInit() {
    this.matSelect.openedChange.subscribe(opened => {
      if (opened) {
        this.matSelect.panel.nativeElement.addEventListener('mouseleave', () => {
          $("#" + this.idForSelect).blur();
        })
      }
    })
  }

  onChangeOfDropdown(event, searchString: string, valueFor: string) {
    if (event.source !== undefined) {
      let viewValue = event.source.selected._element.nativeElement;
      this.dropdownChangeEvent.emit({ value: event.value, viewValue: viewValue.innerText.trim(), type: valueFor });
      searchString = '';
      this.onKey(searchString);
    }
  }

  onKey(searchString: string) {
    if (searchString !== undefined) {
      searchString = searchString.toLowerCase();
    }
    var matches = [];
    this.filteredLists.forEach((element: any) => {
      if (element.entityBusinessName !== null && element.entityBusinessName.toString().toLowerCase().indexOf(searchString) >= 0) {
        const found = matches.some(el => el.entityBusinessName === element.entityBusinessName);
        if (!found) {
          matches.push(element)
        };
      }
    });
    this.lists = matches;
  }

  ngOnDestroy() {
    this.records.unsubscribe();
  }

  highlightFirstOption(e: Event) {
    setTimeout(() => {
      this.matSelect._keyManager.setFirstItemActive();
    }, 10);
  }
}

function cloneObjectWithoutReference(obj) {
  if (null == obj || "object" != typeof obj) return obj;
  var copy = obj.constructor();
  for (var attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
  }
  return copy;
}